export default function LogoIcon(props) {
  return (
    <img width={120} height={24} src="/assets/images/coimex.png" {...props} />
  );
}
